<template>
  <div
    class="wechat-community-entry"
    :class="{ 'wechat-community-entry--expanded': isExpanded }"
    @mouseenter="isExpanded = true"
    @mouseleave="isExpanded = false"
  >
    <button
      class="wechat-community-entry__trigger"
      type="button"
      :aria-expanded="isExpanded"
      aria-controls="wechat-community-panel"
      @click="isExpanded = !isExpanded"
    >
      <img :src="wechatLogo" alt="" aria-hidden="true" />
      <span>加入社群</span>
    </button>

    <section
      v-show="isExpanded"
      id="wechat-community-panel"
      class="wechat-community-entry__panel"
      aria-label="加入官方微信群"
    >
      <strong>加入官方微信群</strong>
      <p>获取最新功能、教程和活动信息</p>
      <div class="wechat-community-entry__qr-wrap">
        <img :src="wechatCommunityQr" alt="小影配音官方微信群二维码" />
      </div>
      <span class="wechat-community-entry__tip">微信扫码加入社群</span>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import wechatCommunityQr from '@/assets/styles/wechat_community.png'
import wechatLogo from '@/assets/wechat-logo.png'

const isExpanded = ref(false)
</script>

<style scoped>
.wechat-community-entry {
  position: relative;
  flex-shrink: 0;
}

.wechat-community-entry__trigger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--tts-space-2);
  height: 42px;
  min-width: 132px;
  padding: 0 var(--tts-space-4);
  border: 1px solid var(--border-primary-soft);
  border-radius: var(--tts-radius-full);
  background: var(--tts-bg-elevated);
  color: var(--tts-primary-700);
  font-size: var(--tts-font-sm);
  font-weight: var(--tts-font-semibold);
  cursor: pointer;
  transition: border-color var(--tts-duration-base) ease, background var(--tts-duration-base) ease, box-shadow var(--tts-duration-base) ease;
}

.wechat-community-entry__trigger img {
  width: 21px;
  height: 21px;
  border-radius: 50%;
}

.wechat-community-entry__trigger:hover,
.wechat-community-entry__trigger[aria-expanded='true'] {
  border-color: var(--tts-primary-300);
  background: var(--color-primary-container);
  box-shadow: var(--tts-shadow-sm);
}

.wechat-community-entry__trigger:focus-visible {
  outline: none;
  box-shadow: var(--tts-shadow-focus);
}

.wechat-community-entry__panel {
  position: absolute;
  top: calc(100% + var(--tts-space-3));
  right: 0;
  width: 220px;
  padding: var(--tts-space-5);
  border: 1px solid var(--border-primary-soft);
  border-radius: var(--tts-radius-lg);
  background: var(--tts-bg-elevated);
  box-shadow: var(--tts-shadow-xl);
  opacity: 0;
  pointer-events: none;
  transform: translateY(-8px) scale(0.98);
  transform-origin: top right;
  transition: opacity var(--tts-duration-base) ease, transform var(--tts-duration-base) ease;
}

.wechat-community-entry--expanded .wechat-community-entry__panel {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
}

.wechat-community-entry__panel strong,
.wechat-community-entry__panel p,
.wechat-community-entry__tip {
  display: block;
  text-align: center;
}

.wechat-community-entry__panel strong {
  color: var(--tts-primary-700);
  font-size: var(--tts-font-base);
}

.wechat-community-entry__panel p {
  margin: var(--tts-space-2) 0 var(--tts-space-3);
  color: var(--tts-text-secondary);
  font-size: var(--tts-font-xs);
  line-height: var(--tts-leading-normal);
}

.wechat-community-entry__qr-wrap {
  padding: var(--tts-space-2);
  border: 1px solid var(--tts-border-light);
  border-radius: var(--tts-radius-md);
  background: var(--tts-bg-primary);
}

.wechat-community-entry__qr-wrap img {
  display: block;
  width: 100%;
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: var(--tts-radius-sm);
}

.wechat-community-entry__tip {
  margin-top: var(--tts-space-3);
  color: var(--tts-text-tertiary);
  font-size: var(--tts-font-xs);
}
</style>
